<template>
  <div>
    <Head title="Barazimet me shoferë" />
    <h1 class="mb-8 text-3xl font-bold">Barazimet me shoferë</h1>

    <div class="flex flex-wrap lg:flex-nowrap mb-6 lg:mb-0 items-center justify-between">

      <div  class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/2 -mb-4">

        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">


          <label class="block text-gray-700">Shoferi shpërndarës:</label>
          <select v-model="form.delivery_driver_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjithë</option>
            <option v-for="driver in deliveryDrivers" :value="driver.id">{{ driver.name }}</option>
          </select>

          <label class="block mt-4 text-gray-700">Të fshira:</label>
          <select v-model="form.trashed" class="form-select mt-1 w-full">
            <option :value="null">Jo të fshira</option>
            <option value="only">Të fshira</option>
            <option value="with">Të gjitha</option>
          </select>
        </search-filter>
      </div>

      <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 lg:-mb-4 py-8">

        <Link class="btn-indigo mr-3" :href="route('admin.finances.delivery-driver-barazimet.create')">
          <span>Regjistro</span>
          <span class="hidden md:inline"> Barazim të ri</span>
        </Link>

        <a :href="route('admin.finances.delivery-driver-barazimet.excel',this.form)" download class="pb-1"><icon name="excel"></icon></a>

      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
<!--      <div class="pr-5 w-full lg:w-1/6">-->
<!--        <label class="form-label text-gray-700">Statusi:</label>-->
<!--        <Multiselect-->
<!--          v-model="form.status_ids"-->
<!--          :options="filterStatuses.options"-->
<!--          mode="tags"-->
<!--          :close-on-select="false"-->
<!--          :searchable="true"-->
<!--          :create-option="false"-->
<!--          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"-->
<!--        />-->

<!--      </div>-->

<!--      <div class="pr-5 w-full lg:w-1/6">-->
<!--        <label class="form-label text-gray-700">Shteti:</label>-->
<!--        <Multiselect-->
<!--          v-model="form.country_ids"-->
<!--          :options="filterCountries.options"-->
<!--          mode="tags"-->
<!--          :close-on-select="false"-->
<!--          :searchable="true"-->
<!--          :create-option="false"-->
<!--          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"-->
<!--        />-->

<!--      </div>-->

<!--      <div class="pr-5 w-full lg:w-1/6">-->
<!--        <label class="form-label text-gray-700">Qyteti:</label>-->
<!--        <Multiselect-->
<!--          v-model="form.city_ids"-->
<!--          :options="filterCities.options"-->
<!--          mode="tags"-->
<!--          :close-on-select="false"-->
<!--          :searchable="true"-->
<!--          :create-option="false"-->
<!--          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"-->
<!--        />-->

<!--      </div>-->

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e regjistrimit:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-1/6">
        <input value="Shpenzime për naftë" disabled type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <select v-model="form.petrol_expenses_sign" class="form-select focus:ring-0 hover:border-indigo-500">
          <option :value="null">Zgjedh shenjën</option>
          <option value=">">{{`>`}}</option>
          <option value="="> {{ `=`}}</option>
          <option value="<"> {{ `<`}}</option>
        </select>
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <input v-model="form.petrol_expenses" type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-1/6">
        <input value="Shpenzime personale" disabled type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <select v-model="form.personal_expenses_sign" class="form-select focus:ring-0 hover:border-indigo-500">
          <option :value="null">Zgjedh shenjën</option>
          <option value=">">{{`>`}}</option>
          <option value="="> {{ `=`}}</option>
          <option value="<"> {{ `<`}}</option>
        </select>
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <input v-model="form.personal_expenses" type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-1/6">
        <input value="Shpenzime tjera" disabled type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <select v-model="form.other_expenses_sign" class="form-select focus:ring-0 hover:border-indigo-500">
          <option :value="null">Zgjedh shenjën</option>
          <option value=">">{{`>`}}</option>
          <option value="="> {{ `=`}}</option>
          <option value="<"> {{ `<`}}</option>
        </select>
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <input v-model="form.other_expenses" type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-1/6">
        <input value="Diferenca" disabled type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <select v-model="form.difference_sign" class="form-select focus:ring-0 hover:border-indigo-500">
          <option :value="null">Zgjedh shenjën</option>
          <option value=">">{{`>`}}</option>
          <option value="="> {{ `=`}}</option>
          <option value="<"> {{ `<`}}</option>
        </select>
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <input v-model="form.difference" type="text" class="form-input focus:ring-0 hover:border-indigo-500">
      </div>
    </div>


    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">Shoferi</th>
          <th class="pb-4 pt-6 px-2">Pako shtesë</th>
          <th class="pb-4 pt-6 px-2">Në shpërndarje</th>
          <th class="pb-4 pt-6 px-2">Në pritje</th>
          <th class="pb-4 pt-6 px-2">Sukses</th>
          <th class="pb-4 pt-6 px-2">Të anuluara</th>
          <th class="pb-4 pt-6 px-2">Totali për dorëzim</th>
          <th class="pb-4 pt-6 px-2">Totali i dorëzuar</th>
          <th class="pb-4 pt-6 px-2">Shpenzime për naftë</th>
          <th class="pb-4 pt-6 px-2">Shpenzime tjera</th>
          <th class="pb-4 pt-6 px-2">Shpenzime personale</th>
          <th class="pb-4 pt-6 px-2">Mjete të kthyera</th>
          <th class="pb-4 pt-6 px-2">Diferenca +/-</th>
          <th class="pb-4 pt-6 px-2">Dëshmia</th>
          <th class="pb-4 pt-6 px-2">Krijuar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="barazim in barazims.data" :key="barazim.id" class="hover:bg-gray-100 focus-within:bg-gray-100">

          <!--          <td class="border-t px-2">-->
          <!--            <input v-model="barazim.selected" :value="barazim.id" class="flex items-center  px-2 py-4" type="checkbox">-->
          <!--          </td>-->

          <td class="w-px border-t px-2">
            <Link class="flex items-center  px-2 py-4" :href="`/admin/financat/barazimet-me-shofere-shperndares/${barazim.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t px-2">
            {{ barazim.id }}
            <icon v-if="barazim.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
          </td>
          <td class="border-t px-2">
            {{ barazim.driver }}
          </td>
          <td class="border-t px-2">
            {{ barazim.total_additional_packages }}
          </td>
          <td class="border-t px-2">
            {{ barazim.shipping_orders }}
          </td>
          <td class="border-t px-2">
            {{ barazim.pending_orders }}
          </td>
          <td class="border-t px-2">
            {{ barazim.delivered_orders }}
          </td>
          <td class="border-t px-2">
            {{barazim.cancelled_orders}}
          </td>
          <td class="border-t px-2">
            {{barazim.expected_amount}}
          </td>
          <td class="border-t px-2">
            {{ barazim.delivered_amount }}
          </td>
          <td class="border-t px-2">
            {{ parseFloat(barazim.petrol_expenses_amount).toFixed(2) }}
          </td>

          <td class="border-t px-2">
            {{ parseFloat(barazim.other_expenses_amount).toFixed(2) }}
          </td>

          <td class="border-t px-2">
            {{ parseFloat(barazim.personal_expenses_amount).toFixed(2) }}
          </td>

          <td class="border-t px-2">
            {{ parseFloat(barazim.money_return_cost).toFixed(2) }}
          </td>

          <td class="border-t px-2">
            <span v-if="barazim.difference > 0">+</span>
            {{ parseFloat(barazim.difference).toFixed(2) }}
          </td>
          <td class="border-t px-2">
            <a v-if="barazim.document_path"  class="px-4 py-1 items-center text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('files.download', {path: barazim.document_path})" download>Shkarko</a>
          </td>
          <td class="border-t px-2">
            {{ barazim.hr_created_at }}
          </td>
          <td class="w-px border-t">

            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <icon name="three-dots" class="block w-12 h-6 fill-gray-400"/>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.delivery-driver-barazim.pdf',{barazim: barazim.id})"   target="_blank">Printo PDF</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('admin.finances.delivery-driver-barazimet.excel.single',{deliveryDriverBarazim: barazim.id})"   target="_blank">Eksporto Excel</a>
                  <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`barazimet-me-shofere-shperndares/${barazim.id}/edit`">Edito</Link>
                  <button v-if="user.role === 'superadmin' && !barazim.deleted_at" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" tabindex="-1" type="button" @click="destroy(barazim.id)">Fshij</button>
                </div>
              </template>
            </dropdown>
          </td>
        </tr>
        <tr v-if="barazims.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje barazim.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="flex flex-wrap">
      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12"
      >
        <option v-if="barazims.meta.total > 15" value="15">15 / {{barazims.meta.total}}</option>
        <option v-if="barazims.meta.total > 30"  value="30">30 / {{barazims.meta.total}}</option>
        <option v-if="barazims.meta.total > 50"  value="50">50 / {{barazims.meta.total}}</option>
        <option v-if="barazims.meta.total > 100"  value="100">100 / {{barazims.meta.total}}</option>
        <option :value="barazims.meta.total">{{barazims.meta.total}} / {{barazims.meta.total}}</option>

      </select-input>

      <pagination class="mt-6" :links="barazims.meta.links"/>
    </div>


  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import axios from 'axios'
import Dropdown from '@/Shared/Dropdown'
import {computed} from 'vue'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import CurrencyNumberFormat from '@/Shared/CurrencyNumberFormat'
import Multiselect from '@vueform/multiselect'
import TextInput from '@/Shared/TextInput'


export default {
  components: {
    CurrencyNumberFormat,
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown,
    FileInput,
    Modal,
    LoadingButton,
    SelectInput,
    Multiselect,
    TextInput
  },
  layout: Layout,
  props: {
    filters: Object,
    barazims: Object,
    deliveryDrivers: Object,
    // statuses: Object,
    // countries: Object,
    // cities: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        delivery_driver_id: this.filters.delivery_driver_id,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,

        petrol_expenses_sign: this.filters.petrol_expenses_sign,
        petrol_expenses: this.filters.petrol_expenses,
        personal_expenses_sign: this.filters.personal_expenses_sign,
        personal_expenses: this.filters.personal_expenses,
        other_expenses_sign: this.filters.other_expenses_sign,
        other_expenses: this.filters.other_expenses,
        difference_sign: this.filters.difference_sign,
        difference: this.filters.difference,

        // status_ids: this.filters.status_ids,
        // country_ids: this.filters.country_ids,
        // city_ids: this.filters.city_ids,

        per_page: this.barazims.meta.total < 15 ? this.barazims.meta.total : this.barazims.meta.per_page,
      },
      // filterStatuses: {
      //   options: this.statuses.map(function(status){
      //     return {value: status.id, label: status.name}
      //   }),
      // },
      // filterCountries: {
      //   options: this.countries.map(function(country){
      //     return {value: country.id, label: country.name}
      //   }),
      // },
      // filterCities: {
      //   options: this.cities.map(function(city){
      //     return {value: city.id, label: city.name}
      //   }),
      // },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/financat/barazimet-me-shofere-shperndares', pickBy(this.form), {preserveState: true})
      }, 150),
    },


  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  methods: {

    destroy(barazimId) {
      if (confirm('Të gjitha dërgesat që i takojnë këtij barazimi do të bëhen të PABARAZUARA. A jeni të sigurt se dëshironi të vazhdoni?')) {
        this.$inertia.delete(`/admin/financat/barazimet-me-shofere-shperndares/${barazimId}`)
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

